import React from 'react';
import { Helmet } from 'react-helmet';
import { getFileUrl } from '@/services/CommonService';

function AuthHeader({ title, faviconIcon }) {
    return (
        <>
            <Helmet>
                <title>{title && title != '' ? `${title}` : 'TabanFood - Restaurant Platform'}</title>
                <link rel="icon" href={faviconIcon && faviconIcon != '' ? getFileUrl(faviconIcon, 'theme') : '/favicon.ico'} />
            </Helmet>
        </>
    );
}

export default AuthHeader;
